import type { ILookup } from '@/interfaces/model/generic.interface';

export type GroupedTramite<T> = {
	tipoTramite: ILookup;
	items: Array<Omit<T, 'tipoTramite'>>;
};

/**
 * Agrupa un listado de elementos basándose en el identificador (`id`) de su `tipoTramite`.
 * Por cada tipo de trámite único, extrae el resto de propiedades de los elementos y las acumula en un array `items`.
 */
export const groupByTipoTramite = <T extends { tipoTramite: ILookup }>(array: T[]): Array<GroupedTramite<T>> =>
	array.reduce<Array<GroupedTramite<T>>>(
		(acc, curr) => {
			const { tipoTramite, ...rest } = curr;
			const index = acc.findIndex((data) => data.tipoTramite.id === tipoTramite.id);

			if (index === -1) {
				acc.push({ tipoTramite, items: [rest] });
			} else {
				acc[index].items.push(rest);
			}
			return acc;
		},
		[],
	);
